import { FlexBox, ShortTaxMessage } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import { useSiteData } from '../../hooks/useSiteData';
import { useBuyItAgainItemContext } from '../contexts/BuyItAgainItemContext';
import { isEstimatedTaxInclusive } from '@vp/om-tax-display';
import { DiscountAwarePriceDisplay } from '@vp/component-library';

/**
 * Uses item contract from BOP to render item prices for a selected quantity (set in BuyItAgainQuantitySelector.js) to reorder on "Buy It Again" page.
 */
export const BuyItAgainItemPrice = () => {
  const { locale, country } = useSiteData();
  const includeTax = isEstimatedTaxInclusive({
    taxCountry: country,
    level: 'item',
    displayFormatType: 'detailed',
  });
  const { currencyCode, fractionDigits, selectedPricedQuantity } =
    useBuyItAgainItemContext();
  const [buyItAgainMessages = {}] = useTranslations(['buyItAgainMessages']);

  // if we don't have a selected priced quantity, don't render anything
  if (!selectedPricedQuantity) {
    return null;
  }

  const listCents = includeTax
    ? selectedPricedQuantity.listPriceCents.taxed
    : selectedPricedQuantity.listPriceCents.untaxed;

  const discountedCents = includeTax
    ? selectedPricedQuantity.discountedPriceCents.taxed
    : selectedPricedQuantity.discountedPriceCents.untaxed;

  return (
    <FlexBox>
      <DiscountAwarePriceDisplay
        fractionDigits={fractionDigits}
        listCents={listCents}
        discountCents={discountedCents}
        currencyCode={currencyCode}
        locale={locale}
        fontSize="small"
        textColor="subtle"
      />
      {includeTax && (
        <ShortTaxMessage ml={2}>
          {buyItAgainMessages.taxInclusive}
        </ShortTaxMessage>
      )}
    </FlexBox>
  );
};
